export function processArchitecturalComparison(data, dateField = "requested_at", view = "month") {
  const parseDate = (d) => new Date(d);
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth(); // 0-indexed
  const currentWeek = getWeek(now);
  const todayISO = now.toISOString().slice(0, 10);

  // Determine labels for x-axis (always two)
  let labels = [];
  if (view === "day") {
    labels = ["Yesterday", "Today"];
  } else if (view === "week") {
    labels = ["Last Week", "This Week"];
  } else if (view === "month") {
    labels = ["Last Month", "This Month"];
  } else if (view === "year") {
    labels = ["Last Year", "This Year"];
  }

  // Counters
  let prevCount = 0;
  let currCount = 0;

  for (const item of data) {
    const d = parseDate(item[dateField]);
    if (isNaN(d)) continue;

    if (view === "day") {
      const dateStr = d.toISOString().slice(0, 10);
      if (dateStr === todayISO) currCount++;
      else {
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        if (dateStr === yesterday.toISOString().slice(0, 10)) prevCount++;
      }
    } else if (view === "week") {
      const yr = d.getFullYear();
      const wk = getWeek(d);
      if (yr === currentYear && wk === currentWeek) currCount++;
      else if (yr === currentYear && wk === currentWeek - 1) prevCount++;
    } else if (view === "month") {
      const yr = d.getFullYear();
      const m = d.getMonth();
      if (yr === currentYear && m === currentMonth) currCount++;
      else if (
        (yr === currentYear && m === currentMonth - 1) ||
        (yr === currentYear - 1 && currentMonth === 0 && m === 11)
      ) prevCount++;
    } else if (view === "year") {
      const yr = d.getFullYear();
      if (yr === currentYear) currCount++;
      else if (yr === currentYear - 1) prevCount++;
    }
  }

  return {
    labels,
    current: [prevCount, currCount], // two points
    previous: [prevCount, currCount], // mirror to keep both lines stretched
  };
}

function getWeek(d) {
  const date = new Date(d.getTime());
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
  const week1 = new Date(date.getFullYear(), 0, 4);
  return 1 + Math.round(
    ((date.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7
  );
}
